/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_MessageInputs */

const en_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Message`)
};

const fr_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message d’état`)
};

const de_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statusmeldung`)
};

const it_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggio di stato`)
};

const ru_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение о состоянии`)
};

const es_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje de estado`)
};

const zh_cn2_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`状态消息`)
};

const ja_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ステータスメッセージ`)
};

const hi_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति संदेश`)
};

const pt_pt2_status_message = /** @type {(inputs: Status_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem de status`)
};

/**
* | output |
* | --- |
* | "Status Message" |
*
* @param {Status_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const status_message = /** @type {((inputs?: Status_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_status_message(inputs)
	if (locale === "de") return de_status_message(inputs)
	if (locale === "it") return it_status_message(inputs)
	if (locale === "ru") return ru_status_message(inputs)
	if (locale === "es") return es_status_message(inputs)
	if (locale === "zh-CN") return zh_cn2_status_message(inputs)
	if (locale === "ja") return ja_status_message(inputs)
	if (locale === "hi") return hi_status_message(inputs)
	if (locale === "pt-PT") return pt_pt2_status_message(inputs)
	return en_status_message(inputs)
});